import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.map.js";
import Vue from 'vue';
import { Dropdown, Offcanvas } from 'bootstrap';
import Cookies from 'js-cookie';
import './navigation';
import './searchFilters';
import './ajax-load-more';
import DietitianSearchForm from './components/Search/DietitianSearchForm.vue';
import RightToPracticeSearchForm from './components/Search/RightToPracticeSearchForm.vue';

if (document.getElementById('app')) {
  Vue.component('dietitian-search-form', DietitianSearchForm);
  Vue.component('right-to-practice-search-form', RightToPracticeSearchForm);
  new Vue({
    el: '#app'
  });
}
/**
 * Register Bootstrap Dropdown
 */


var dropdownElementList = [].slice.call(document.querySelectorAll('.dropdown-toggle'));
var dropdownList = dropdownElementList.map(function (dropdownToggleEl) {
  return new Dropdown(dropdownToggleEl);
});
/**
 * Register Bootstrap Offcanvas
 */

var offcanvasElementList = [].slice.call(document.querySelectorAll('.offcanvas'));
var offcanvasList = offcanvasElementList.map(function (offcanvasEl) {
  return new Offcanvas(offcanvasEl);
});
/**
 * Homepage notice
 */

var notice = document.querySelector('.home .notice');

if (notice) {
  var closeBtn = notice.querySelector('.btn-close');
  closeBtn.addEventListener('click', function () {
    Cookies.set('tolle_hide_notice', true);
  });
}